import { Popconfirm, Switch } from 'antd';
import { PopconfirmProps } from 'antd/lib';

export const DisableAction = ({ onConfirm, title, checked, disabled }: PopconfirmProps & { checked: boolean }) => (
  <Popconfirm
    className='ml-2'
    placement='left'
    title={title}
    disabled={disabled}
    onConfirm={onConfirm}
  >
    <Switch
      size='small'
      checked={checked}
      disabled={disabled}
      title='Disable/Enable'
    />
  </Popconfirm>
);
